import React from 'react';
import { Accordion } from '../../../base/Accordion';
import { Badge } from '../../../base';

interface MailApprovalCardProps {
  recipients?: string;
  subject?: string;
  content?: string;
  title?: string;
  answered?: boolean;
  footer?: React.ReactNode;
}

/** 메일 발송 요청/완료 */
export const MailApprovalCard: React.FC<MailApprovalCardProps> = ({
  recipients,
  subject,
  content,
  title = '메일 발송 요청',
  answered = false,
  footer,
}) => {
  const openByDefault = !answered;

  const Label = (
    <div className="card-label">
      <Badge accent="normal">요청</Badge>
      <div className="tool-name">{title}</div>
    </div>
  );

  const Contents = (
    <div className="mail-approval-card-body">
      <div className="mail-approval-meta">
        <div className="mail-approval-meta-row">
          <span className="mail-approval-meta-label">받는 사람</span>
          <span className="mail-approval-meta-value">{recipients ?? '-'}</span>
        </div>
        <div className="mail-approval-meta-row">
          <span className="mail-approval-meta-label">제목</span>
          <span className="mail-approval-meta-value">{subject ?? '-'}</span>
        </div>
      </div>
      <div className="mail-approval-body">{content ?? ''}</div>
    </div>
  );

  return (
    <div className="msg-content">
      <div className="tool-result">
        <div className="result-card">
          <Accordion
            key={answered ? 'closed' : 'open'}
            data={[{ content: Contents, icon: '', label: Label, value: 'mail-approval' }]}
            isMultiple={true}
            defaultValue={openByDefault ? ['mail-approval'] : ['']}
            onChange={() => {}}
          />
          {footer}
        </div>
      </div>
    </div>
  );
};
